import { autorun, makeAutoObservable } from 'mobx';
import { inject, injectable } from 'inversify';
import { UserRole } from '@mobx/interfaces';
import { ProfileModule } from '@mobx/services/profile';
import { type RolesService, RolesServiceIdentifier } from '@shared/types/mobx/services/roles';
import { getSelectableRoles } from '@shared/utils/helpers/selectableRoles';

@injectable()
export class CabinetSidebarViewModel {
  isOpen: boolean;

  currentRole: UserRole | null;

  roles: UserRole[] | null;

  userInfo: any | null;

  constructor(@inject(RolesServiceIdentifier) private rolesModule: RolesService, private profileModule: ProfileModule) {
    makeAutoObservable(this);

    this.isOpen = false;

    this.currentRole = this.rolesModule.currentRole;
    this.roles = this.rolesModule.roles;

    this.userInfo = this.profileModule.userData.info;

    autorun(() => {
      this.currentRole = this.rolesModule.currentRole;
    });

    autorun(() => {
      this.roles = this.rolesModule.roles;
    });

    autorun(() => {
      this.userInfo = this.profileModule.userData.info;
    });
  }

  /**
   * Роли, доступные на экране выбора (та же функция, что у /auth/select-role). Нужны карточке
   * «Выберите роль»: показывать её есть смысл, только если на экране выбора будет что выбрать
   * (дефект «сброс роли на ABONENT после очистки сессии»).
   */
  get selectableRoles(): UserRole[] {
    return getSelectableRoles(this.roles);
  }
}
